module.exports = __webpack_public_path__ + "img/menu33.8faf2cc9.png";